class CodeParachuteMobileMenuPart {
	constructor(id) {
		this.SHOW_CLASS = 'show'
		this.EXPAND_CLASS = 'expand'
		this.FOR_ATTR = 'data-for'
		this.part = document.getElementById(id)
		this.id = id

		const buttons = this.part.querySelectorAll(`[${this.FOR_ATTR}]`)
		for (let index = 0; index < buttons.length; index++) {
			const button = buttons[index]
			const forId = button.getAttribute(this.FOR_ATTR)
			const li = this.part.querySelector(`#${forId}`)
			button.addEventListener('click', (e) => {
				e.stopPropagation()
				e.preventDefault()
				if (li.classList.contains(this.SHOW_CLASS)) li.classList.remove(this.SHOW_CLASS)
				else li.classList.add(this.SHOW_CLASS)
			})
		}

		//Only close mobile if anchor link on same page
		const links = this.part.querySelectorAll('a')
		for (let index = 0; index < links.length; index++) {
			const link = links[index]
			if (link.href.includes('#')) {
				if (window.location.pathname === link.pathname) {
					link.addEventListener('click', () => {
						this.hide()
					})
				}
			}
		}

		const menuItems = this.part.querySelectorAll('.menu-item')
		for (let index = 0; index < menuItems.length; index++) {
			const menuItem = menuItems[index]
			const subMenu = menuItem.querySelector('.sub-menu')
			const firstLink = menuItem.querySelector('a')
			menuItem.addEventListener('click', (e) => {
				e.stopPropagation()
				if (subMenu) {
					if (subMenu.classList.contains(this.SHOW_CLASS)) {
						subMenu.classList.remove(this.SHOW_CLASS)
						menuItem.classList.remove(this.EXPAND_CLASS)
					}
					else {
						subMenu.classList.add(this.SHOW_CLASS)
						menuItem.classList.add(this.EXPAND_CLASS)
					}
				}
				else {
					if (firstLink) {
						firstLink.click()
					}
				}
			})
		}

		window.addEventListener('resize', (e) => {
			if (window.innerWidth > 900) this.hide()
		})
	}

	setTogglesOn() {
		const toggles = document.querySelectorAll(`[data-toggle-for="${this.id}"]`);
		for (let index = 0; index < toggles.length; index++) {
			const toggle = toggles[index]
			toggle.classList.add('toggled')
		}
	}

	setTogglesOff() {
		const toggles = document.querySelectorAll(`[data-toggle-for="${this.id}"]`);
		for (let index = 0; index < toggles.length; index++) {
			const toggle = toggles[index]
			toggle.classList.remove('toggled')
		}
	}

	show() {
		this.part.classList.add(this.SHOW_CLASS)
		this.part.style.pointerEvents = 'all'
		this.part.style.overflow = 'auto';
		BslHtml.get().lock()
		this.setTogglesOn()
	}

	hide() {
		this.part.classList.remove(this.SHOW_CLASS)
		this.part.style.pointerEvents = 'none'
		this.part.style.overflow = '';
		BslHtml.get().unlock()
		this.setTogglesOff()
	}

	toggle() {
		if (this.part.classList.contains(this.SHOW_CLASS)) this.hide()
		else this.show()
	}

	static init(id) {
		return new this(id)
	}
}
const mobileMenu = CodeParachuteMobileMenuPart.init('codeparachute-mobile-menu')
